module.exports = __webpack_public_path__ + "static/screen-web-win-laptop@2x-ab8ae024a7adb4e8b1b92722e7b3e9aa.webp";